export const loadConfigCached = async (cacheFor = 24 * 60 * 60 * 1000) => {
    const url = "/config.json";
    const now = Date.now();

    const cached = localStorage.getItem(url);
    if (cached) {
        const parsed = JSON.parse(cached);
        if (now - parsed.timestamp < cacheFor) {
            return parsed.data; // return cached version
        }
    }

    // Fetch fresh
    const res = await fetch(url);
    const data = await res.json();

    // Store cache
    localStorage.setItem(
        url,
        JSON.stringify({ data, timestamp: now })
    );

    return data;
};
